import { AlignmentPointType, } from "../../core/alignment/interface";
/** Current 2D distance of the centerline point with the given id; undefined if it no longer exists. */
export function getMarkerDistanceById(alignment, id) {
    return alignment.resolveCenterLinePoint(id)?.distanceFromStart;
}
/** Looks up a centerline point's current label by id, falling back to its IP projection point; undefined if it no longer exists. */
export function getMarkerLabelById(alignment, id) {
    return alignment.resolveCenterLinePoint(id)?.label;
}
/** Resolves a tracked marker id (raw id or IP id) to the centerline point's current live id; undefined if it no longer exists. */
export function getMarkerCurrentId(alignment, id) {
    return alignment.resolveCenterLinePoint(id)?.id;
}
/** Whether the given centerline point id is tied to a horizontal IP (has a stable id). */
export function isIpAssociatedMarker(alignment, id) {
    return (alignment
        .resolveCenterLinePoint(id)
        ?.pointType.includes(AlignmentPointType.IP_PROJECTION) ?? false);
}
/** Looks up a centerline point's label by `markerId`, falling back to its 2D projected distance from start; undefined if none matches. */
export function getMarkerLabel(alignment, projectedDistanceFromStart, markerId) {
    if (markerId) {
        const labelById = getMarkerLabelById(alignment, markerId);
        if (labelById !== undefined)
            return labelById;
    }
    return alignment.centerLinePoints.find((p) => Math.abs(p.distanceFromStart - projectedDistanceFromStart) < 1e-3)?.label;
}
/** Looks up a centerline point's id by its 2D projected distance from start; undefined if none matches. */
export function getMarkerIdAt(alignment, projectedDistanceFromStart) {
    return alignment.centerLinePoints.find((p) => Math.abs(p.distanceFromStart - projectedDistanceFromStart) < 1e-3)?.id;
}
/** Whether a centerline point of the given type (e.g. station, PVI) still lies at the given 2D projected distance. */
export function hasCenterLinePointAt(alignment, projectedDistanceFromStart, pointType) {
    return alignment.centerLinePoints.some((p) => p.pointType.includes(pointType) &&
        Math.abs(p.distanceFromStart - projectedDistanceFromStart) < 1e-3);
}
//# sourceMappingURL=section-marker-resolver.js.map